'use strict';

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var fetch = require('isomorphic-fetch');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var fetch__default = /*#__PURE__*/_interopDefaultLegacy(fetch);

var _excluded = ["error", "status"];
var oneHour = 60 * 60 * 1000;

if (!process) {
  throw new Error('👨‍✈️ Cache stays in backend');
}

var cache = {
  cache: {},
  refetchMap: {},
  repeatMap: {},

  /**
   *
   * @param {string} name
   * @returns any
   */
  get: function get(name) {
    return this.cache[name];
  },

  /**
   *
   * @param {Object} options
   * @param {string} options.name - name of the cache
   * @param {any} options.data - data to cache
   * @param {string} [options.url] - url for refetching
   * @param {number} options.ttl - time to live in milliseconds
   */
  set: function set(_ref) {
    var _this = this;

    var name = _ref.name,
        data = _ref.data,
        url = _ref.url,
        ttl = _ref.ttl;

    if (url) {
      this.refetchMap[name] = url;
    }

    if (!name || !data) {
      throw new Error('name and data are required');
    }

    this.cache[name] = data;

    if (ttl && Number.isInteger(ttl)) {
      setTimeout(function () {
        _this.remove(name);
      }, ttl);
    }
  },

  /**
   * @typedef {Object} options
   * @property {string} name
   * @property {string} url
   * @property {boolean} [refetchCache]
   * @property {number} [timeoutTime]
   * @property {number} [refetchTime]
   * @property {(data: any) => boolean} assertResponseIsInvalid
   * @property {number} ttl
   */
  create: function create(_ref2) {
    var _this2 = this;

    return _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2() {
      var name, url, _ref2$refetchCache, refetchCache, _ref2$timeoutTime, timeoutTime, _ref2$refetchTime, refetchTime, assertResponseIsInvalid, ttl;

      return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              name = _ref2.name, url = _ref2.url, _ref2$refetchCache = _ref2.refetchCache, refetchCache = _ref2$refetchCache === void 0 ? false : _ref2$refetchCache, _ref2$timeoutTime = _ref2.timeoutTime, timeoutTime = _ref2$timeoutTime === void 0 ? 5000 : _ref2$timeoutTime, _ref2$refetchTime = _ref2.refetchTime, refetchTime = _ref2$refetchTime === void 0 ? oneHour / 2 : _ref2$refetchTime, assertResponseIsInvalid = _ref2.assertResponseIsInvalid, ttl = _ref2.ttl;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var performCreate = function performCreate() {
                  if (!name) {
                    reject(new Error('name is required'));
                  }

                  if (_this2.cache[name] && !refetchCache) {
                    resolve(_this2.cache[name]);
                  }

                  _this2.refetchMap[name] = url;
                  fetch__default["default"](url).then(function (_ref3) {
                    var error = _ref3.error,
                        status = _ref3.status,
                        data = _objectWithoutProperties__default["default"](_ref3, _excluded);

                    if (error || status >= 300) {
                      throw new Error(error !== null && error !== void 0 ? error : 'Unsuccesful cache fetch');
                    }

                    if (data) {
                      if (refetchCache) {
                        _this2.repeatMap[name] = setTimeout( /*#__PURE__*/_asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
                          return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  performCreate();

                                case 1:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        })), refetchTime);
                      }

                      if (assertResponseIsInvalid && assertResponseIsInvalid(data) === true) {
                        throw new Error('fetch assertion triggered');
                      } else {
                        _this2.set({
                          name: name,
                          data: data,
                          url: url,
                          ttl: ttl
                        });
                      }

                      resolve(_this2.cache[name]);
                    }
                  })["catch"](function (error) {
                    if (refetchCache) {
                      setTimeout(function () {
                        performCreate();
                      }, timeoutTime);
                    } else {
                      reject(error);
                    }
                  });
                };

                performCreate();
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   *
   * @param {string} name
   */
  remove: function remove(name) {
    delete this.cache[name];
  },
  flush: function flush() {
    this.cache = {};
  }
};

module.exports = cache;
//# sourceMappingURL=cache.js.map
